<template>
  <div class="user-creation">
    <h1 class="subtitle-1 grey--text ml-3 mt-3">
      {{ $t("user.create.title") }}
    </h1>
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex md6>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="user.firstname"
              prepend-icon="person"
              :rules="$rules('user.name')"
              :label="$t('user.fields.firstname') + '*'"
              required
            ></v-text-field>
            <v-text-field
              v-model="user.lastname"
              prepend-icon="person"
              :rules="$rules('user.name')"
              :label="$t('user.fields.lastname') + '*'"
              required
            ></v-text-field>
            <v-text-field
              v-model="user.email"
              prepend-icon="email"
              :rules="$rules('user.email')"
              :label="$t('user.fields.email') + '*'"
              required
            ></v-text-field>
            <v-text-field
              v-model="user.phone1"
              v-mask="'(###-###-####)'"
              prepend-icon="phone"
              :rules="$rules('user.phone1')"
              :label="$t('user.fields.phone-1') + '*'"
              required
            ></v-text-field>
            <v-text-field
              v-model="user.phone2"
              v-mask="'(###-###-####)'"
              prepend-icon="phone"
              :rules="$rules('user.phone2')"
              :label="$t('user.fields.phone-2')"
            ></v-text-field>
            <v-text-field
              v-model="user.password"
              prepend-icon="lock"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :type="show ? 'text' : 'password'"
              :rules="$rules('user.newPassword')"
              autocomplete="new-password"
              :label="$t('user.fields.password') + '*'"
              required
              @click:append="show = !show"
            ></v-text-field>
            <v-select
              v-model="user.role"
              :items="availableRoles"
              prepend-icon="school"
              item-text="text"
              item-value="value"
              :rules="$rules('user.role')"
              :label="$t('user.fields.role') + '*'"
              required
            ></v-select>
            <v-text-field
              v-if="user.role === $t('user.roles.student.title')"
              v-model="user.age"
              prepend-icon="child_care"
              mask="##"
              type="number"
              :rules="$rules('user.age')"
              :label="$t('user.roles.student.age')"
            ></v-text-field>
          </v-form>
          <v-card-actions>
            <v-btn outlined @click="cancel">
              {{ $t("app.buttons.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid || !filled"
              dark
              color="primary"
              :loading="posting"
              @click="submit"
            >
              {{ $t("app.buttons.submit") }}
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import adaptersOut from "@/services/data-adapter/outgoing/user";

export default {
  data: () => ({
    user: {
      role: "",
      age: "",
      firstname: "",
      lastname: "",
      phone1: "",
      phone2: "",
      email: "",
      password: ""
    },
    valid: true,
    show: false,
    posting: false
  }),

  computed: {
    availableRoles: function() {
      return [
        this.$t("user.roles.student.title"),
        this.$t("user.roles.teacher.title")
      ];
    },
    filled: function() {
      return (
        this.user.role &&
        this.user.firstname &&
        this.user.lastname &&
        this.user.phone1 &&
        this.user.email &&
        this.user.password
      );
    }
  },

  mounted: function() {
    this.$nextTick(function() {});
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.posting = true;
        adaptersOut.newUser(this.user).then(user => {
          this.$http
            .post(
              "/users",
              { user },
              { withCredentials: true, credentials: "include", mode: "cors" }
            )
            .then(request => this.submitSuccessful(request.data))
            .catch(error => this.submitFailed(error));
        });
      }
    },

    submitSuccessful(req) {
      this.posting = false;
      this.$store.dispatch(
        "system/setStatus",
        {
          type: "success",
          message: this.$t("app.actions.success.creation")
        },
        { root: true }
      );
      this.$router.push("/users-management");
    },

    submitFailed(error) {
      this.posting = false;
      if (process.env.NODE_ENV !== "production") {
        console.log(error.response.data.errors);
      }

      var parsedError = this.$t("validation.user.failed");
      if (
        error.response.data.errors[0].detail ==
        "The the user's email has already been taken."
      ) {
        parsedError = this.$t("validation.user.duplicate-email");
      }

      this.$store.dispatch(
        "system/setStatus",
        {
          type: "error",
          message: parsedError
        },
        { root: true }
      );
    },

    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>
